// @flow
import { createSelector } from "reselect"

import Journey from "common/records/Journey"
import { getJourney } from "../journey/reducer"
import type { Action } from "./actions"
import type { State } from "booking/services/types"

/**
 * Shadow journey is present, if some trip/flight is marked as hidden,
 * normal journey contains only visible (not hidden) flights (parts),
 * but shadow contains everything, so we can render it in itinerary.
 *
 * MR: Throwaway tickets #3882
 * If nothing is hidden, shadow journey is null and default journey is used
 */
const shadowJourneyReducer = (state: ?Journey = null, action: Action): ?Journey => {
  switch (action.type) {
    case "SET_SHADOW_JOURNEY":
      return action.payload
    default:
      return state
  }
}

export default shadowJourneyReducer

// Data selectors
// ===
const internalGetShadowJourney = (state: State) => state.reservation.shadowJourney

export const isShadowJourneySet: $FlowFixMe = createSelector(
  internalGetShadowJourney,
  Boolean,
)

export const getShadowJourney: $FlowFixMe = createSelector(
  internalGetShadowJourney,
  getJourney,
  (shadowJourney: Journey, journey: Journey) => shadowJourney || journey,
)
